import React, { useEffect, useState } from "react";
import NewsModal from "./NewsModal";
import "./newsletter.css";
// import ReactTooltip from "react-tooltip";
import client from "../../../utils/prismicHelpers";
import * as queries from "../../../utils/prismicQueries";
import img from "../../../assets/images/newsletter.png";
const Newsletter = () => {
  const [newsLetter, setNewsletter] = useState(false);
  const [homeDoc, setHomeDoc] = useState(null);
  const [tooltip, setTooltip] = useState(true);
  useEffect(() => {
    client
      .query({
        query: queries.heroSection,
      })
      .then((response) => {
        const homeDocContent = response.data.allHomes.edges[0].node;
        setHomeDoc(homeDocContent);
      })
      .catch((error) => {
        console.error(error);
      });
  });

  return (
    <div>
      {homeDoc?.show_chat && (
        <>
          <img
            className="chat"
            onClick={() => setNewsletter(!newsLetter)}
            src={homeDoc?.chat_img?.url}
            data-tip
            data-for="subscribe"
          />
          {tooltip && (
            <div>
              {homeDoc?.toltip_text && (
                <>
                  <span
                    className="cross-container"
                    onClick={() => setTooltip(false)}
                  >
                    <svg
                      viewBox="0 0 24 24"
                      role="presentation"
                      style={{ width: "1.5rem", height: "1.5rem" }}
                    >
                      <path
                        d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                        style={{ fill: "currentcolor" }}
                      ></path>
                    </svg>
                  </span>

                  <div className="card toolpop">
                    <div className="card-header poptext">
                      {homeDoc?.toltip_text}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
          {/* {homeDoc?.toltip_text && (
            <ReactTooltip
              id="subscribe"
              effect="solid"
              border
              textColor="#1E538F"
              backgroundColor="white"
              className="extraClass"
              clickable="true"
            >
              <h5> {homeDoc?.toltip_text}</h5>
            </ReactTooltip>
          )} */}
        </>
      )}
      <NewsModal homeDoc={homeDoc} setShow={setNewsletter} show={newsLetter} />
    </div>
  );
};

export default Newsletter;
